import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "full-width" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editable_block_input = _resolveComponent("editable-block-input")!
  const _component_editable_block = _resolveComponent("editable-block")!

  return (_openBlock(), _createBlock(_component_editable_block, {
    title: "Payment details",
    layout: "grid",
    "model-value": _ctx.paymentDetails,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:client', _ctx.client.sys.id, { financial: { ..._ctx.paymentDetails, ...$event } }))),
    "column-count": 1
  }, {
    default: _withCtx(({ editState }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_editable_block_input, {
          label: "Bank name",
          modelValue: editState.bank_name,
          "onUpdate:modelValue": ($event: any) => ((editState.bank_name) = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        _createVNode(_component_editable_block_input, {
          label: "BIC / SWIFT code",
          modelValue: editState.bic,
          "onUpdate:modelValue": ($event: any) => ((editState.bic) = $event),
          tooltip: "The BIC / SWIFT code is a unique code that identifies the bank and branch where the account is held."
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        _createVNode(_component_editable_block_input, {
          label: "IBAN number",
          modelValue: editState.iban,
          "onUpdate:modelValue": ($event: any) => ((editState.iban) = $event)
        }, {
          static: _withCtx(({ inputState }) => [
            _createTextVNode(_toDisplayString(_ctx.formatIBAN(inputState.value)), 1)
          ]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}